const getOrderStatusDataForTrack = status => {
  let statusId = null;

  if (status) {
    switch (status.toLowerCase()) {
      case "order_accepted_with_additional_time_restaurant_confirm_expected":
        statusId = 1;
        break;

      case "order_accepted":
        statusId = 1;
        break;

      case "order_preparing":
        statusId = 1;
        break;

      case "order_prepared":
        statusId = 1;
        break;

      case "order_in_driver":
        statusId = 2;
        break;

      case "order_completed":
        statusId = 4;
        break;

      case "in_address":
        statusId = 3;
        break;

      default:
        statusId = null;
    }
  }

  return statusId;
};

export const allStatus = [
  {
    id: 1,
    footer: "Preparing",
    title: "Order being prepared!",
    inDriver: false,
    inRestaurant: true,
    icon: "/svg/preparing-status.svg"
  },
  {
    id: 2,
    title: "Food on its way!",
    footer: "On its way",
    inDriver: true,
    inRestaurant: false,
    icon: "/svg/in-driver-status.svg"
  },
  {
    id: 3,
    title: "Your food is near you!",
    footer: "Near you",
    inDriver: true,
    inRestaurant: false,
    icon: "/svg/in-address-status.svg"
  },
  {
    id: 4,
    footer: "Completed",
    title: "Your food is delivered!",
    inDriver: false,
    inRestaurant: false,
    icon: "/svg/delivered-status.svg"
  }
];

export default getOrderStatusDataForTrack;
